export const MODULE_STATE = Object.freeze({
  INIT: "init",
  LOADED: "loaded"
});

export const CRITICAL_MODULES = ["app", "assets"];

export const BUSINESS_LINE = Object.freeze({
  DTF: "Transfers",
  STICKER: "Stickers",
  SPANGLE: "Spangles",
  BLANKS: "Blanks",
  HARDGOODS: "Hardgoods",
  DIGITAL_ASSETS: "Digital Assets",
  PRINT: "Print"
});

export const BLANKS_GROUP = Object.freeze([BUSINESS_LINE.BLANKS, BUSINESS_LINE.HARDGOODS]);

export const TRANSFERS_GROUP = Object.freeze([
  BUSINESS_LINE.DTF,
  BUSINESS_LINE.STICKER,
  BUSINESS_LINE.SPANGLE,
  BUSINESS_LINE.DIGITAL_ASSETS
]);
